import type { ReactNode } from "react";
import { icons } from "./icons";
import { logos } from "./logos";

export const availableIcons = {
  ...icons,
  ...logos,
};

export type AvailableIcon = keyof typeof availableIcons;

export type IconDefinition = {
  viewBox: string;
  children: (fill: string, solid: boolean) => ReactNode;
};
